import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    shipment_id: yup.string().id().label('Shipment ID').required(),
    date: yup.date().label('Date').required(),
    type: yup.string().oneOf(['pickup', 'delivery']).label('Type').required(),
    notes: yup.string().trim().nullable().label('Notes')
  });
};
